module.exports = __webpack_public_path__ + "static/media/Simisear_gaussian2.f080cf25.png";